import './CCHeader.css';

export default function CCHeader() {
    return (
        <div className='creator-cash-header'>
            <div className='creator-cash-app-logo' />
        </div>
    )
}